import { FormInputTypes, GridColSpan, TypedFormInputs } from 'components/form';
import { safeCompileRegExp } from 'utils/index';

export type CustomWorkerDataField = {
  fieldDataType: string;
  fieldLabel: string;
  validationMessage?: string | null;
  validationRegex?: string | null;
  isRequired: boolean;
};

export const getDefaultValueForCustomDataType = (
  dataType: string,
): string | null => {
  switch (dataType) {
    case 'string':
      return '';
    default:
      throw new Error(
        `${dataType} data type is not supported for custom fields.`,
      );
  }
};

export const getElementForCustomDataType = (
  dataType: string,
): FormInputTypes => {
  switch (dataType) {
    case 'string':
      return FormInputTypes.Field;
    default:
      throw new Error(
        `${dataType} data type is not supported for custom fields.`,
      );
  }
};

export const generateCustomWorkerDataFieldInputs = (
  customWorkerDataFields: CustomWorkerDataField[],
  smSpan: GridColSpan = GridColSpan.SmSpan6,
): TypedFormInputs<any> => {
  return customWorkerDataFields.reduce(
    (acc, customField) => ({
      ...acc,
      [customField.fieldLabel]: {
        element: getElementForCustomDataType(customField.fieldDataType),
        label: customField.fieldLabel,
        layout: [GridColSpan.SpanFull, smSpan],
        ...(customField.isRequired || customField.validationRegex
          ? {
              validation: {
                ...(customField.isRequired && {
                  required: true,
                }),
                ...(customField.validationRegex && {
                  pattern: {
                    value: safeCompileRegExp(customField.validationRegex),
                    message: customField.validationMessage,
                  },
                }),
              },
            }
          : {}),
      },
    }),
    {},
  );
};
